import { ListItem as NovaBaseListItem } from '@fme-nova/components'
import { default as MuiBaseListItem, ListItemProps } from '@mui/material/ListItem'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiListItem: MsdkStyledComponent<ListItemProps | any> = styled(MuiBaseListItem)`
  &:hover {
    background-color: ${COLORS.action.hover};
  }
  &:disabled {
    color: ${COLORS.text.disabled};
  }
  &:visited {
    color: ${COLORS.text.primary};
  }
  &:active {
    background-color: ${COLORS.primary.selected};
  }
  &:focus {
    background-color: ${COLORS.action.focus};
  }
`

export const ListItem = createComponentWrapperWithRef<ListItemProps | any>(
  {
    mui: MuiListItem,
    nova: NovaBaseListItem,
  },
  'ListItem',
)
